module.exports = __webpack_public_path__ + "img/1498843916.bc6519a7.jpg";